import React from "react";

interface ViewProps {
    view: 'mobile' | 'desktop'
}

export default function HeroSkeleton({view}:ViewProps){
    return (
        <div role="status" className="space-y-8 animate-pulse md:space-y-0 md:space-x-8 rtl:space-x-reverse md:flex md:items-center h-full">
            <div className="w-full flex flex-col justify-center items-center">
                {view === 'mobile' ?
                <>
                    <div className="flex w-full mt-8 mb-16 px-6">
                        <div className="h-5 bg-gray-200 rounded-full dark:bg-gray-400 w-14 mr-auto ml-0 my-auto"></div>
                        <div className="h-9 bg-gray-200 rounded-xl dark:bg-gray-400 w-20 ml-auto mr-0 my-auto"></div>
                    </div>
                    <div className="h-16 bg-gray-200 rounded-full dark:bg-gray-400 w-10/12 max-w-xl mb-10"></div>
                    <div className="h-12 bg-gray-200 rounded-xl dark:bg-gray-400 w-80 md:w-96 mb-12"></div>
                    <div className="flex items-center justify-center w-40 h-52 bg-gray-300 rounded-xl sm:w-96 sm:h-48 dark:bg-gray-400">
                        <svg className="w-8 h-8 text-gray-200 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                            <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"/>
                        </svg>
                    </div>
                    <div className="h-12 bg-gray-200 rounded-xl dark:bg-gray-400 w-80 md:w-96 mt-14 md:mt-12 mb-4"></div>
                    <div className="h-12 bg-gray-200 rounded-xl dark:bg-gray-400 w-80 md:w-96 mb-8"></div>
                    <div className="h-3 bg-gray-200 rounded-full dark:bg-gray-400 w-40 mb-12"></div>
                </>
                :
                <>
                    <div className="flex w-full mt-8 mb-12 px-6 xl:px-20">
                        <div className="h-6 bg-gray-200 rounded-full dark:bg-gray-400 w-16 xl:w-20 mr-auto ml-0 my-auto"></div>
                        <div className="h-10 bg-gray-200 rounded-full dark:bg-gray-400 w-20 ml-auto mr-0 my-auto"></div>
                    </div>
                    <div className="h-8 bg-gray-200 rounded-full dark:bg-gray-400 w-96 mb-4"></div>
                    <div className="h-8 bg-gray-200 rounded-full dark:bg-gray-400 w-72 mb-9"></div>
                    <div className="h-16 bg-gray-200 rounded-xl dark:bg-gray-400 w-full max-w-2xl mb-12"></div>
                    <div className="flex items-center justify-center w-80 h-64 bg-gray-300 rounded-xl sm:w-96 dark:bg-gray-400">
                        <svg className="w-8 h-8 text-gray-200 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                            <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"/>
                        </svg>
                    </div>
                    <div className="h-16 bg-gray-200 rounded-xl dark:bg-gray-400 w-7/12 xl:w-full xl:max-w-4xl mt-16 mb-2"></div>
                </>
                }   
            </div>
            <span className="sr-only">Loading...</span>
        </div>
    )
}